module.exports = __webpack_public_path__ + "img/icon／24sz.dd71913b.svg";